import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { companyAutocompleteQueryKeys } from "./queryKeyFactory";

const useCompanyAutocompleteListQuery = (domains: string[], withDataCredits: boolean = false) => {
    return useQuery({
        queryKey: companyAutocompleteQueryKeys.companyAutocompleteList(domains),
        queryFn: async ({ signal }) => {
            return salesApiService.fetchAutocompleteCompanies(
                { domains, withDataCredits },
                {
                    cancellation: signal,
                },
            );
        },
        enabled: !!domains.length,
        staleTime: Infinity,
    });
};

export default useCompanyAutocompleteListQuery;
